import { formatDate } from '@/lib/format';

export interface DateDisplayProps {
  value: string | Date;
  timezone?: string;
  format?: 'short' | 'long' | 'datetime';
  className?: string;
}

export function DateDisplay({
  value,
  timezone = 'America/Lima',
  format = 'short',
  className,
}: DateDisplayProps): JSX.Element {
  return <span className={className}>{formatDate(value, timezone, format)}</span>;
}
